import {
  createConnectionApiAction,
  createConnectorAddedSuccessStep,
  createFullWidthRowLayout,
} from './connectorSchema.helpers';

export const CloudflareSchema = {
  name: 'Cloudflare Connector',
  steps: {
    0: {
      name: 'Step 1',
      elements: [
        {
          type: 'description',
          description: 'Please provide API credentials to connect.',
          column: 0,
        },
        {
          name: 'clientEmail',
          label: 'Email',
          description: 'Please enter your Cloudflare email',
          type: 'text',
          required: true,
          column: 1,
        },
        {
          name: 'clientAPIKey',
          label: 'API Key',
          description: 'Please enter your Cloudflare API Key',
          type: 'password',
          required: true,
          column: 2,
        },
      ],
      layout: createFullWidthRowLayout(3),
      action: createConnectionApiAction({ includeNullData: true }),
    },
    1: createConnectorAddedSuccessStep(
      'Cloudflare has been successfully added as a connector.'
    ),
  },
};
